// Thresholds and display constants for the Statistics tab.

// Status thresholds + enum are shared with the Evolution metric cards.
export {
  GRADE_RATIO_GREEN, GRADE_RATIO_ORANGE, SATISFACTION_GREEN, SATISFACTION_ORANGE, STATUS
} from '../ui/KpiCard/status'

export const VIEW_MODES = {
  GRADE: 'grade',
  SATISFACTION: 'satisfaction'
}

export const GRANULARITY_OPTIONS = [
  { value: 'day', label: 'Quotidien' },
  { value: 'week', label: 'Hebdomadaire' },
  { value: 'month', label: 'Mensuel' }
]

// Cross-drafts only: one point per planification, available when no draftId.
export const DRAFT_GRANULARITY = { value: 'draft', label: 'Par planification' }

export const DEFAULT_PER_PAGE = 10
export const QUESTION_OPTIONS_PREVIEW = 5

export const SECTION_EMPTY_MESSAGE = 'Les détails de cette section apparaîtront ici '
  + 'une fois les données disponibles.'

export const SELECTION_TOOLTIP = '% : Part de cette réponse parmi toutes les réponses sur 100%.'
export const SELECTION_MULTI_TOOLTIP = '% : Part des contrôles ayant signalé cette réponse sur 100%.'
